<template>
  <div class="al-textarea" :class="[{ caret: icon }, size]">
    <textarea
      ref="textarea"
      v-model="textareaValue"
      :placeholder="placeholder"
      :cols="colsTextarea"
      :rows="rowsTextarea"
      :maxlength="maxlength"
      :class="[{ 'is-auto-resize': autoResize }]"
      test-id="al-textarea"
      @input="input"
      @blur="blur"
    ></textarea>
    <div v-if="icon" class="caret-items">
      <al-icon :icon="icon" @click.prevent.stop="iconClick" />
    </div>
  </div>
</template>
<script>
import AlIcon from '../../inline/icon/AlIcon.vue';

export default {
  components: {
    AlIcon
  },
  props: {
    placeholder: { type: String, default: '' },
    cols: { type: Number, default: 5 },
    rows: { type: Number, default: 5 },
    value: { type: String, default: '' },
    extraSpaces: { type: Boolean, default: true },
    size: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: null
    },
    autoResize: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: [Number, String],
      default: 2000
    }
  },
  data() {
    return {
      theValue: ''
    };
  },
  computed: {
    colsTextarea() {
      return !this.autoResize ? this.cols : 0;
    },
    rowsTextarea() {
      return !this.autoResize ? this.rows : 0;
    },
    textareaValue: {
      get() {
        this.setInitialResize();
        return this.value;
      },
      set(value) {
        this.setInitialResize();
        this.theValue = value;
      }
    }
  },
  mounted() {
    this.setInitialResize();
  },
  methods: {
    input(evt) {
      this.textareaEvents(evt, 'input');
    },
    blur(evt) {
      this.textareaEvents(evt, 'blur');
    },
    textareaEvents(evt, type) {
      if (this.autoResize) {
        this.mixinAutoResize(evt.target);
      }
      const res = this.extraSpaces ? this.removeExtraSpace(evt.target.value) : evt.target.value;
      this.$emit(type, res);
    },
    iconClick() {
      this.$emit('icon-click');
    },
    removeExtraSpace(string) {
      return string.replace(/\n+$/, '');
    },
    setInitialResize() {
      if (this.autoResize) {
        this.$nextTick(() => {
          const element = this.$el.querySelector('textarea');
          element.setAttribute('style', 'min-height: auto');
          element.setAttribute('style', `min-height: ${element.scrollHeight}px`);
        });
      }
    },
    mixinAutoResize(target) {
      // eslint-disable-next-line no-param-reassign
      target.style.minHeight = 'auto';
      // eslint-disable-next-line no-param-reassign
      target.style.minHeight = `${target.scrollHeight}px`;
      // eslint-disable-next-line no-param-reassign
      target.style.maxHeight = 'auto';
      // eslint-disable-next-line no-param-reassign
      target.style.maxHeight = `${target.scrollHeight}px`;
    }
  }
};
</script>
<style lang="scss">
.al-textarea {
  position: relative;

  textarea {
    border: 1px solid color(white, darken, 2);
    border-radius: 5px;
    padding: 16px;
    width: 100%;

    &::placeholder {
      color: #9b9f9f;
    }

    &:focus {
      border: 1px solid color(green);
      outline: none;
    }

    &.is-auto-resize {
      height: 44px;
      overflow: hidden;
      padding: 10px 9px;
      resize: none;
    }
  }
}

.al-textarea.sm {
  textarea {
    background: color(white, lighten, 1);
    border: 1px solid color(white, darken, 1);

    &:focus {
      background: color(green, lighten, 4);
      border: 1px solid color(green, lighten, 4);
      outline: none;
    }

    &.is-auto-resize {
      height: 36px;
      padding: 4.8px 9px;
    }
  }
}

.al-textarea.caret {
  textarea {
    padding-right: 44px;
  }

  .caret-items {
    align-items: center;
    cursor: pointer;
    display: inline-flex;
    height: 44px;
    justify-content: center;
    position: absolute;
    right: 0;
    top: 0;
    visibility: hidden;
    width: 44px;
    z-index: 2;
  }

  &.sm {
    .caret-items {
      height: 36px;
      width: 36px;
    }
  }
}

.al-textarea.caret:hover {
  .caret-items {
    visibility: visible;
  }
}
</style>
